import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { trackLinkClick } from '../../analytics';
import translate from '../../functions/translate';
import the from '../../objects/the';
import Button from '../button';
import Div from '../div';
import InputField from '../input.field';

const EnterPasswordSection = props => {
   
    const [passwordShown, setPasswordShown] = useState(false);
    const [inputRef, setInputRef] = useState(null);
    const [inputWidth, setInputWidth] = useState(0);
   
    const visibilityIsControlled = props.showPassword !== undefined;
    const togglePasswordVisiblity = () => {
        if (visibilityIsControlled) {
            props.onShowPasswordChange(!props.showPassword);
        } else {
            setPasswordShown(current => !current);
        }
    };
   
    const getInputRef = ref => {
        if (props.inputRef) {
            props.inputRef(ref);
        }
        setInputRef(ref);
    };
   
   
    useEffect(() => {
        const getInputWidth = () => {
            if (inputRef) {
                setInputWidth(inputRef.offsetWidth);
            }
        };
      
        getInputWidth();
        window.addEventListener('resize', getInputWidth);
        return () => window.removeEventListener('resize', getInputWidth);
    }, [inputRef]);
   
    const showPassword = visibilityIsControlled ? props.showPassword : passwordShown;
   
   
    const columnDefs = {
        cols: 11,
        colsSM: 10,
        colsMD: 9,
        colsLG: 6,
        colsXL: 5
    };
    if (props.columnWidth) {
        for (let key in columnDefs) {
            columnDefs[key] = props.columnWidth;
        }
    }
   
    return <>
        <Div isRow={true}>
            <Div {...columnDefs}>
                <div style={{position: 'relative'}}>
                    <InputField
                        aria-invalid={(!!props.errorMessage).toString()}
                        errorMessage={props.errorMessage}
                        id={props.id ? props.id : null}
                        inputRef={getInputRef}
                        label={props.label || 'Password'}
                        name={'password'}
                        onBlur={props.onBlur}
                        onChange={props.onChange}
                        onFocus={props.onFocus}
                        style={{minWidth: '100%'}}
                        type={showPassword ? "text" : "password"}
                        value={props.value}
                    />
                    <i id="eyeGlyphicon" className={showPassword ? "far fa-eye-slash" : "far fa-eye"}
                        onClick={togglePasswordVisiblity}
                        style={{position: 'absolute', top: 71, left: inputWidth - 75}}>
                    </i>
                    <Button
                        analyticsDescription={'toggle password visibility'}
                        color={'white'}
                        displayAs={'button'}
                        onClick={togglePasswordVisiblity}
                        size={'small'}
                        style={{
                            backgroundColor: 'transparent',
                            border: 'none',
                            position: 'absolute',
                            left: inputWidth - 75,
                            top: 62,
                            color: the.color.tarheelBlue,
                            paddingRight: 3
                        }}
                    >
                        {showPassword ? translate('Hide') : translate('Show')}
                        <span className={'ds-u-visibility--screen-reader'}> {translate('Password')}</span>
                    </Button>
                </div>
            
                {props.showForgotPasswordLink &&
            <Div isRow={true}>
                <Div
                    cols={12}>
                    <Div marginTop={0}>
                        <Div>
                            <Link style={{
                                color: the.color.tarheelBlue
                            }}
                            to="/forgot-password"
                            onClick={trackLinkClick}
                            >
                                {translate('Forgot password?')}
                            </Link>
                        </Div>
                    </Div>
                </Div>
            </Div>
                }
            </Div>
        </Div>
    </>
};

EnterPasswordSection.propTypes = {
    columnWidth: PropTypes.number,
    errorMessage: PropTypes.string,
    id: PropTypes.string,
    inputRef: PropTypes.func,
    label: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onShowPasswordChange: PropTypes.func,
    showForgotPasswordLink: PropTypes.bool,
    showPassword: PropTypes.bool,
    value: PropTypes.string,
};

export default EnterPasswordSection;